var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7593 2.46872C4.7593 2.35015 4.65634 2.25719 4.53924 2.27583C2.80106 2.55254 1.66797 3.92884 1.66797 5.89503V11.1951C1.66797 13.1587 2.80108 14.5318 4.5393 14.8077C4.65638 14.8263 4.7593 14.7333 4.7593 14.6147V2.46872Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8111 2.20801H5.95781C5.84735 2.20801 5.75781 2.29755 5.75781 2.40801V14.6747C5.75781 14.7851 5.84735 14.8747 5.95781 14.8747H10.8105C12.9178 14.8747 14.3331 13.396 14.3331 11.1947V5.89467C14.3331 3.69001 12.9178 2.20801 10.8111 2.20801Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.1604 10.9281H10.199C10.9944 10.9281 11.6417 10.2821 11.6417 9.48814C11.6417 8.69348 10.9944 8.04814 10.199 8.04814H9.12235C8.87835 8.04814 8.67969 7.84748 8.67969 7.60148C8.67969 7.35881 8.87835 7.1615 9.12235 7.1615H10.8724C11.1484 7.1615 11.3724 6.9375 11.3724 6.6615C11.3724 6.3855 11.1484 6.1615 10.8724 6.1615H10.1604V5.86816C10.1604 5.59216 9.93635 5.36816 9.66035 5.36816C9.38435 5.36816 9.16035 5.59216 9.16035 5.86816V6.1615H9.12235C8.32702 6.1615 7.67969 6.80683 7.67969 7.60148C7.67969 8.39881 8.32702 9.04814 9.12235 9.04814H10.199C10.443 9.04814 10.6417 9.24548 10.6417 9.48814C10.6417 9.73081 10.443 9.92814 10.199 9.92814H8.44902C8.17302 9.92814 7.94902 10.1521 7.94902 10.4281C7.94902 10.7041 8.17302 10.9281 8.44902 10.9281H9.16035V11.2215C9.16035 11.4975 9.38435 11.7215 9.66035 11.7215C9.93635 11.7215 10.1604 11.4975 10.1604 11.2215V10.9281Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.18c26fbf4d1aa5f44c888225c0dbc7e7.svg";
export { ForwardRef as ReactComponent };